import React, { useState } from "react"
import { MultiLangJobStatus, MultilangJob } from "src/services/api/document"
import DownloadButton from "src/components/browser/buttons/DownloadButton"
import OpenInEditorButton from "src/components/browser/buttons/OpenInEditorButton"
import SeeQuoteButton from "src/components/browser/buttons/SeeQuoteButton"
import SeeQuoteModal from "./SeeQuoteModal"

interface JobButtonProps {
  job: MultilangJob
  showDownloadButton?: boolean
  onModalClose?: () => void
  iconOnly?: boolean
  onOpenEmailModal?: () => void
}

const JobButton: React.FC<JobButtonProps> = ({ job, showDownloadButton, onModalClose, iconOnly, onOpenEmailModal }) => {
  const [open, setOpen] = useState(false)
  const completed = showDownloadButton && job.resultFilesReady
  const needsAcceptance = job.status === MultiLangJobStatus.QUOTED

  const handleOpen = () => {
    setOpen(true)
  }
  const handleClose = () => {
    setOpen(false)
    onModalClose && onModalClose()
  }

  if (completed) {
    return <DownloadButton job={job} iconOnly={iconOnly} color={job.status === MultiLangJobStatus.CANCELLED ? "gray" : "electricMint"}/>
  }

  if (job.openableAssignmentId) {
    return <OpenInEditorButton assignmentId={job.openableAssignmentId} iconOnly={iconOnly} onOpenEmailModal={onOpenEmailModal} />
  }

  if (["QUOTED", "QUOTING"].includes(job.status)) {
    return (
      <>
        <SeeQuoteModal open={open} handleClose={handleClose} job={job} />
        <SeeQuoteButton onClick={handleOpen} stillQuoting={!needsAcceptance} iconOnly={iconOnly} />
      </>
    )
  }

  return null
}

export default JobButton
